export default __webpack_public_path__ + "static/media/background-popup.cd6c9831.svg";